import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock, LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Seo } from "@/components/Seo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const result = await login(email, password);
    setLoading(false);
    if (result.ok) navigate("/admin");
    else setError(result.error);
  };

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4" data-testid="admin-login-page">
      <Seo title="Painel Administrativo | HG Móveis" noindex />
      <div className="w-full max-w-sm bg-white rounded-2xl shadow-lg border border-slate-200 p-8">
        <div className="text-center">
          <img src="/assets/logo.png" alt="HG Móveis" className="h-16 w-16 mx-auto" />
          <h1 className="mt-4 font-heading text-xl font-bold text-gray-900">Painel HG Móveis</h1>
          <p className="text-sm text-gray-500 mt-1">Acesso restrito à administração</p>
        </div>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label htmlFor="admin-email">E-mail</Label>
            <Input
              id="admin-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@hgmoveis.com.br"
              className="mt-1.5"
              required
              autoComplete="email"
              data-testid="admin-login-email"
            />
          </div>
          <div>
            <Label htmlFor="admin-password">Senha</Label>
            <Input
              id="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="mt-1.5"
              required
              autoComplete="current-password"
              data-testid="admin-login-password"
            />
          </div>

          {error && (
            <p className="text-sm text-red-600 bg-red-50 rounded-lg px-3 py-2" data-testid="admin-login-error">
              {error}
            </p>
          )}

          <Button type="submit" className="w-full rounded-full h-11" disabled={loading} data-testid="admin-login-submit">
            <LogIn className="w-4 h-4" /> {loading ? "Entrando..." : "Entrar"}
          </Button>
        </form>

        <p className="mt-6 text-xs text-gray-400 text-center flex items-center justify-center gap-1">
          <Lock className="w-3 h-3" /> Área protegida por login e senha
        </p>
      </div>
    </div>
  );
}
